"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
var services_1 = require("stremio/services");
var components_1 = require("stremio/components");
var constants_1 = require("../constants");
var Menu_less_1 = __importDefault(require("./Menu.less"));
var Menu = function (_a) {
    var _b, _c, _d, _e;
    var _f, _g;
    var selected = _a.selected, streamingServer = _a.streamingServer, onSelect = _a.onSelect;
    var t = (0, react_i18next_1.useTranslation)().t;
    var shell = (0, services_1.useServices)().shell;
    var settings = (0, react_1.useMemo)(function () {
        var _a;
        return (((_a = streamingServer === null || streamingServer === void 0 ? void 0 : streamingServer.settings) === null || _a === void 0 ? void 0 : _a.type) === 'Ready' ?
            streamingServer.settings.content : null);
    }, [streamingServer === null || streamingServer === void 0 ? void 0 : streamingServer.settings]);
    return (react_1.default.createElement("div", { className: Menu_less_1.default['menu'] },
        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Menu_less_1.default['button'], (_b = {}, _b[Menu_less_1.default['selected']] = selected === constants_1.SECTIONS.GENERAL, _b)), title: t('SETTINGS_NAV_GENERAL'), "data-section": constants_1.SECTIONS.GENERAL, onClick: onSelect }, t('SETTINGS_NAV_GENERAL')),
        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Menu_less_1.default['button'], (_c = {}, _c[Menu_less_1.default['selected']] = selected === constants_1.SECTIONS.PLAYER, _c)), title: t('SETTINGS_NAV_PLAYER'), "data-section": constants_1.SECTIONS.PLAYER, onClick: onSelect }, t('SETTINGS_NAV_PLAYER')),
        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Menu_less_1.default['button'], (_d = {}, _d[Menu_less_1.default['selected']] = selected === constants_1.SECTIONS.STREAMING, _d)), title: t('SETTINGS_NAV_STREAMING'), "data-section": constants_1.SECTIONS.STREAMING, onClick: onSelect }, t('SETTINGS_NAV_STREAMING')),
        react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Menu_less_1.default['button'], (_e = {}, _e[Menu_less_1.default['selected']] = selected === constants_1.SECTIONS.SHORTCUTS, _e)), title: t('SETTINGS_NAV_SHORTCUTS'), "data-section": constants_1.SECTIONS.SHORTCUTS, onClick: onSelect }, t('SETTINGS_NAV_SHORTCUTS')),
        react_1.default.createElement("div", { className: Menu_less_1.default['spacing'] }),
        react_1.default.createElement("div", { className: Menu_less_1.default['version-info-label'], title: process.env.VERSION },
            t('SETTINGS_APP_VERSION'),
            ": ",
            process.env.VERSION),
        react_1.default.createElement("div", { className: Menu_less_1.default['version-info-label'], title: process.env.COMMIT_HASH },
            t('SETTINGS_BUILD_VERSION'),
            ": ",
            process.env.COMMIT_HASH),
        (settings === null || settings === void 0 ? void 0 : settings.serverVersion) &&
            react_1.default.createElement("div", { className: Menu_less_1.default['version-info-label'], title: settings.serverVersion },
                t('SETTINGS_SERVER_VERSION'),
                ": ",
                settings.serverVersion),
        typeof ((_g = (_f = shell === null || shell === void 0 ? void 0 : shell.transport) === null || _f === void 0 ? void 0 : _f.props) === null || _g === void 0 ? void 0 : _g.shellVersion) === 'string' &&
            react_1.default.createElement("div", { className: Menu_less_1.default['version-info-label'], title: shell.transport.props.shellVersion },
                t('SETTINGS_SHELL_VERSION'),
                ": ",
                shell.transport.props.shellVersion)));
};
exports.default = Menu;
